const NAME = 'AXEPTIO';
const CNameMapping = {
  [NAME]: NAME,
  Axeptio: NAME,
  axeptio: NAME,
};

export { NAME, CNameMapping };
